import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Form from '@/views/form.vue'
import Result from '@/views/result.vue'
//import store from "@/store";
//import axios from "axios";
//import {Toast} from "vant";


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            auth: true,
            keepAlive: false,
            title: '验真查询'
        }
    },
    {
        path: '/form',
        name: 'Form',
        component: Form,
        meta: {
            auth: true,
            keepAlive: false,
            title: '验真查询'
        }
    },
    {
        path: '/result',
        name: 'Result',
        component: Result,
        meta: {
            auth: true,
            keepAlive: false,
            title: '查询结果'
        }
    },

]

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({y: 0}),
    routes
})

export default router
